import React from "react";
import { Switch, Route } from "react-router-dom";
import Authorization from "../../components/Authorization";

import BookingCodesRouter from "./BookingCodes";
import ProductsRouter from "./Products";
import RoutesRouter from "./Routes";
import DirectionsRouter from "./Directions";
import LocationsRouter from "./Locations";
import OrdersRouter from "./Orders";
import TripsRouter from "./Trips";
import ELDProcessingRouter from "./ELDProcessing";
import OrderArchivesRouter from "./OrderArchives";
import BookingHistoryRouter from "./BookingHistory";
import OrderDispatchingRouter from "./OrderDispatching";

const Dispatch = Authorization(["ADMIN", "FIN", "DISP"]);

const DispatchProcessingRouter = () => (
  <Switch>
    <Route path="/dispatch/booking-codes">
      <BookingCodesRouter />
    </Route>
    <Route path="/dispatch/products">
      <ProductsRouter />
    </Route>
    <Route path="/dispatch/locations">
      <LocationsRouter />
    </Route>
    <Route path="/dispatch/routes">{Dispatch(RoutesRouter)}</Route>
    <Route path="/dispatch/directions">
      <DirectionsRouter />
    </Route>
    <Route path="/dispatch/orders">
      <OrdersRouter />
    </Route>
    <Route path="/dispatch/scheduling">
      <TripsRouter />
    </Route>
    <Route path="/dispatch/order-dispatching">
      <OrderDispatchingRouter />
    </Route>
    <Route path="/dispatch/bookings">
      <BookingHistoryRouter />
    </Route>
    <Route path="/dispatch/ELD">
      <ELDProcessingRouter />
    </Route>
    <Route path="/dispatch/order-archive">
      <OrderArchivesRouter />
    </Route>
  </Switch>
);

export default DispatchProcessingRouter;
